export const BUNNY_CDN = 'https://vz-ef3e8794-d5f.b-cdn.net';

/** URL of the animated hover-preview asset Bunny generates per video. */
export function getBunnyPreviewUrl(bunnyVideoId: string): string {
  return `${BUNNY_CDN}/${bunnyVideoId}/preview.webp`;
}
